import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { enviroment } from 'src/environments/environment';
import { Account } from '../model/form/account';
import { AuthService } from './auth.service';
import { AccountResponse, PaginationAccountResponse } from '../model/response/account-response';
import { GetAllPublicProjectsResponse, PaginationPublicProjects, PublicProjectResponse } from '../public/public-project-response';
import { StorageUsedResponse } from '../model/response/storage-used-response';
import { CreateSubscriptionRequest, SubscriptionCreated, TokensAdded } from '../model/response/plan-response';
import { OnlineUser } from '../model/online-user';

@Injectable({
  providedIn: 'root'
})

export class AdminService {

  httpOptions: {};
  adminUrl: string;
  userUrl: string;

  constructor(private http: HttpClient, private authService: AuthService) { 
    let idToken = sessionStorage.getItem('idToken') || "" 
    this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${idToken}`
        })
      }
    this.adminUrl = enviroment.BASE_URL_API + '/admin'
    this.userUrl = enviroment.BASE_URL_API + '/user'
  }
  //utlizando api antiga de admin
  getAllUsers(page: number, itensPage: number):Observable<PaginationAccountResponse> {
    const userID = this.authService.getUserInformations()
    const params = new HttpParams()
      .set('requesterUserId', userID ?? '')
      .set('page', String(page))
      .set('pageItens', String(itensPage));
    return this.http.get<PaginationAccountResponse>(
      `${this.userUrl}/GetAllUsers`,
      { ...this.httpOptions, params }
    ).pipe(tap())
  }
  //utlizando api antiga de admin
  getAllUsersQuery(page: number, itensPage: number, query: string):Observable<PaginationAccountResponse> {
    const userID = this.authService.getUserInformations()
    const params = new HttpParams()
      .set('requesterUserId', userID ?? '')
      .set('page', String(page))
      .set('pageItens', String(itensPage))
      .set('query', query);
    return this.http.get<PaginationAccountResponse>(
      `${this.userUrl}/AdminGetUserSearchQuery`,
      { ...this.httpOptions, params }
    ).pipe(tap())
  }
  //utlizando api antiga de admin
  getAllProjects(page: number, itensPage: number): Observable<PaginationPublicProjects> {
    const url = this.userUrl + `/adminGetAllProjects?page=${page}&pageItens=${itensPage}`
    return this.http.get<PaginationPublicProjects>(url, this.httpOptions).pipe(tap())
  }
  

  /**
   * Envia a nova senha no corpo JSON (evita vazamento em logs de URL).
   * O endpoint deve aceitar `{ "pass": "..." }` no body; ajuste a API se ainda só ler query string.
   */
  changeUserPassword(userId: string, newPassword: string): Observable<any> {
    const url = this.adminUrl + `/user/${userId}/pass_set/`;
    return this.http.post(url, { pass: newPassword }, this.httpOptions);
  }
  //utlizando api antiga de admin
  getStorageUsed(userId: string): Observable<StorageUsedResponse> {
    const url = this.userUrl + `/${userId}/storage_use`;
    return this.http.get<StorageUsedResponse>(url, this.httpOptions).pipe(
      tap(response => {
      })
    );
  }

  getFtPassUsers(minCheckins: number): Observable<any> {
    const url = this.adminUrl + `/ftpassUsers?minCheckins=${minCheckins}`;
    return this.http.get<any>(url, this.httpOptions).pipe(tap());
  }

  getUser(userId: string): Observable<AccountResponse> {
    return this.http.get<AccountResponse>(`${this.adminUrl}/user/${userId}`, this.httpOptions).pipe(tap());
  }

  updateUser(account: AccountResponse): Observable<AccountResponse> {
    return this.http.put<AccountResponse>(`${this.adminUrl}/user/${account.userId}`, account, this.httpOptions).pipe(tap());
  }

  createSubscription(userId: string, body: CreateSubscriptionRequest): Observable<SubscriptionCreated> {
    const url = this.adminUrl + `/user/${userId}/subscription`;
    return this.http.post<SubscriptionCreated>(url, body, this.httpOptions);
  }

  addTokens(userId: string, amount: number): Observable<TokensAdded> {
    const url = this.adminUrl + `/user/${userId}/tokens`;
    return this.http.post<TokensAdded>(url, { amount }, this.httpOptions);
  }

  getOnlineUsers(): Observable<OnlineUser[]> {
    return this.http.get<OnlineUser[]>(`${this.adminUrl}/users/online`, this.httpOptions);
  }

}
